//export const server_api_url = 'https://www.kalilo.fr/webapi';
//export const server_img_url = 'https://www.kalilo.fr/img/';
// CONSTANTES IMAGES

//export const server_api_url = 'https://www.kalilo.fr/webapi';
//export const server_img_url = 'https://www.kalilo.fr/img/';
// CONSTANTES IMAGES

//export const server_api_url = 'http://vps-0aabc1b5.vps.ovh.net:3012';
//export const server_img_url = 'http://vps-0aabc1b5.vps.ovh.net/kalilo/img/';


//export const server_api_url = 'https://www.kalilo.fr/webapi';
const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();

export const server_api_url = configuredApiUrl
  ? configuredApiUrl.replace(/\/+$/, '')
  : '/kaliloapiv3';
export const server_img_url = 'https://www.kalilo.fr/img/';
